import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const DivideBackground = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 102}
          height={props.height ?? 123}
          viewBox="0 0 102 123"
          fill="none"
        >
          <Path
            d="M51.1367 122.978C41.4625 122.978 34.263 116.297 34.263 106.943C34.263 97.5888 41.4625 90.9074 51.1367 90.9074C61.036 90.9074 68.0104 97.5888 68.0104 106.943C68.0104 116.297 61.036 122.978 51.1367 122.978ZM0.515625 47.7014H101.758V73.3132H0.515625V47.7014ZM51.1367 32.1115C41.4625 32.1115 34.263 25.4302 34.263 16.0763C34.263 6.72236 41.4625 0.0410156 51.1367 0.0410156C61.036 0.0410156 68.0104 6.72236 68.0104 16.0763C68.0104 25.4302 61.036 32.1115 51.1367 32.1115Z"
            fill={props.color ?? '#FFF5DD'}
            fillOpacity="0.95"
          />
        </Svg>
      </View>
    );
  },
);

export { DivideBackground };
